import React, { useEffect, useState } from "react";
import minilogo from "assets/images/logo.png";
import logo from "assets/images/icon_logo.svg";
import { getTandC } from "services/TandCServices";
function TermsAndConditions(props) {
  const { mini, miniDrawerWidth } = props;
  const [tnc, SetTnc] = useState("T&C");

  let fetchTermsAndConditions = async () => {
    await getTandC().then(response => {
      if (response.success) {
        let policy = response.data.find(x => x.TandC_for === "Merchant");
        console.log("policy", policy);
        SetTnc(policy.TandC_description);
      }
    });
  };
  useEffect(() => {
    fetchTermsAndConditions();
  }, []);
  console.log("tnc", tnc);

  return (
    <div className="tnc-header">
      <div className="tnc-heading w-100">
        <div className="logo-text simple-text fs-20 bold-text">
          <img
            src={mini && miniDrawerWidth !== "260px" ? logo : minilogo}
            alt=""
          />
        </div>
      </div>
      <div className="container tnc-container">
        <div className="">
          <h4 className="mb-3 mt-2">Terms and Conditions</h4>
          <p dangerouslySetInnerHTML={{ __html: tnc }}></p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
